import $ from "vendor/zepto";
import { GameOverScreen } from "@pch/path-gamemanager-js";
import renderTemplate from "keno/app/modules/templateLoader";
import animationUtil from "keno/app/modules/animationUtil";
import NoPassword from "keno/app/views/NoPassword";
// import numberFormat from "keno/app/modules/numberFormat";
// import NumberScrollView from "keno/app/views/NumberScroll";

const GO_HOME_CLASS = `gos--return-home`;
const ONBOARDING_CLASS = `gos--onboarding`;

class NoPasswordGameOverScreen extends GameOverScreen {
	constructor(opts) {
		super(opts);
		this.opts.submitNumbersMessage = this.opts.submitNumbersMessage || false;
		this.opts.errorMessages.top = `Oops!`;
		this.opts.errorMessages.bottom = `We are experiencing technical difficulties. Please try again!`;
		this._autoClaim = true; // always true for V4 games
		this.gameNode = this.rootNode;
		this.showing = false;
		this.EVENTS.BACK_HOME = `onBackHome`;
	}

	mount(rootNode) {
		super.mount(rootNode);
	}

	// @override
	reset() {
		super.reset();
		this.elements.gos.classList.remove(GO_HOME_CLASS);
		this.elements.gos.classList.remove(ONBOARDING_CLASS);
	}
	// @override
	setup(errResponse, startResp) {
		if (errResponse) {
			// gosClass.push( TD_ERROR_CLASS );
			// messages = this.getErrorMessages(errResponse);

			//open default technical difficulties screen
			this.hasError = true;
			//stop from ever showing twice
			if (!this.showing) {
				this.open();
			}
		} else if (startResp.body.slots_response) {
			this.processSlotsResponse(startResp);
		} else {
			this.processScratchResponse(startResp);
		}

		//startresp stuff goes here to build game overscreen
	}
	processSlotsResponse(startResp) {
		if (
			startResp.body.slots_response.result &&
			startResp.body.slots_response.result.prize &&
			startResp.body.slots_response.result.prize.prizeType.name === `CASH`
		) {
			this.cash = startResp.body.slots_response.result.prize.prizeValue;
		} else if (startResp.body.tokens) {
			this.tokens = startResp.body.tokens;
		}
	}
	processScratchResponse(startResp) {
		if (startResp.getWinsByType(`TOKEN`)[0]) {
			this.tokens = startResp.getWinsByType(`TOKEN`)[0].value;
			this.totalTokens = this.opts.totalTokens + this.tokens;
			window.totalNoPasswordUserTokens = this.totalTokens; //update no password tokens with latest from game
		}
		if (startResp.getWinsByType(`MONETARY`)[0]) {
			this.cash = startResp.getWinsByType(`MONETARY`)[0].value;
		}
	}

	onNoPassForfeit() {
		this.fireEvent(this.EVENTS.CONTINUE);
	}
	// // @override
	// getWinHTML ( win ) {
	// 	// this.totalTokens = 0;

	// 	// if ( !PCHUSER.isFullyRegistered ) {
	// 	// 	this.totalTokens = win.value + window.scratchCardTokens;
	// 	// } else {
	// 	// 	this.totalTokens = win.value;
	// 	// }
	// 	// // const formatted = numberFormat( totalTokens );
	// 	// // const chunks = formatted.split( `` );
	// 	const winText = [
	// 		`<span class="numberscroll numberscroll--highlight numberscroll--animated">`
	// 	];

	// 	if ( win.type === PRIZE_TYPES.CASH ) {
	// 		winText.push( `<span class='numberscroll__currency'>$</span>` );
	// 	}
	// 	chunks.forEach( digit => {
	// 		if ( digit === `,` || digit === `.` ) {
	// 			winText.push( `<span class="numberscroll__sep">` + digit + `</span>` );
	// 		} else {
	// 			winText.push( `<span class="numberscroll__digit">` + digit + `</span>` );
	// 		}
	// 	});
	// 	winText.push( `</span>` );
	// 	return winText.join( `` );
	// }

	// @override
	open() {
		const inline = !!this.gameNode;

		//check carry over tokens if available
		if (!this.totalTokens) {
			this.totalTokens = window.totalNoPasswordUserTokens || this.tokens;
		}

		//allow redirect on live drawing now
		this.showing = true;
		this.view = $(
			renderTemplate(`shared/gos-no-password.html`, {
				inline: inline,
				mobile: window.isMobile,
				tokens: this.tokens,
				totalTokens: this.totalTokens || 0,
				cash: this.cash || 0,

				cardNum: this.opts.cardData.cardNum,
				cardStyle: this.opts.cardData.cardStyle,
				submitNumbersMessage: this.opts.submitNumbersMessage
			})
		);

		if (inline) {
			const gameNode = $(this.gameNode);
			//append to first child in gamenode which is from the scratch card package

			if (this.opts.gameType === `slots`) {
				this.gameContainer = $(gameNode.children(`div`)[4]);
			} else {
				this.gameContainer = $(gameNode.children(`div`)[0]);
			}
			if (this.gameContainer.length === 0) {
				this.gameContainer = $(gameNode.children(`section`)[0]);
			}
			this.gameContainer.append(this.view.get(0));

			animationUtil.animateFast(this.view, animationUtil.ANIMS.FADE_IN_DOWN);
			this.view.on(`click`, `[data-dismiss="modal"]`, e => {
				e.preventDefault();
				this.fireEvent(this.EVENTS.CONTINUE);
			});
			$("body").css("position", "fixed");
		} else {
			document.body.appendChild(this.view.get(0));
			this.view.modal({ backdrop: false });
			this.view.on(`hiddenbsmodal`, function() {
				this.view.remove();
			});
		}
		this.noPassword = new NoPassword();
		this.noPassword.mount(`.gos--no-password`, false);
		this.noPassword.addEvent(
			this.noPassword.EVENTS.CREATE_PASS,
			this.onCreatePass.bind(this)
		);
		this.noPassword.addEvent(
			this.noPassword.EVENTS.FORFEIT,
			this.onNoPassForfeit.bind(this)
		);
		//this.bindClickEvents();
	}
	onCreatePass() {
		this.fireEvent(this.EVENTS.CONTINUE);
	}
	//@override
	close() {
		animationUtil.animateFast(this.view, animationUtil.ANIMS.FADE_OUT, () => {
			this.view.removeClass(`gos--show`);
		});
	}

	onBackHomeClick(ev) {
		ev.preventDefault();
		this.fireEvent(this.EVENTS.BACK_HOME);
	}
}

export default NoPasswordGameOverScreen;
